var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusThick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 238",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 53",
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 3,
    d: "M7.5 0v15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 54",
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 3,
    d: "M15 7.5H0"
  })));
}

export default __webpack_public_path__ + "ec8f44fbe85df1f906767b175f594b8b.svg";
export { SvgPlusThick as ReactComponent };